import React from 'react'
import { FormattedMessage } from 'react-intl'

import { TtIcon, TtDropdown, TtMenu, TtMenuItem } from '@23/ui-react'

import { addNewMix, setEditingMix } from '../../../../firebase/hooks/useMixes'
import type { Layout } from '../../../../firebase/model/mix'
import { LayoutPreview } from '../LayoutPreview/LayoutPreview'
import layouts from '../mixes.json'

import './NewMix.scss'

const NewMix = () => {
  return (
    <TtDropdown placement="top">
      <button slot="trigger" className="new-mix-trigger" type="button">
        <TtIcon library="one" name="plus" />
        <div className="new-mix-trigger-label ">
          <FormattedMessage defaultMessage="New Mix" />
        </div>
      </button>
      <TtMenu
        className="new-mix-layouts-preview"
        onTtSelect={async (event) => {
          const selected = event.detail.item
          const idx = +selected.value
          const layout: Layout = {
            feeds: layouts[idx].feeds.map((l) => ({ ...l })),
          }
          const newMixId = await addNewMix(layout)
          setEditingMix(newMixId)
        }}
      >
        {layouts.map((layout, idx) => (
          // eslint-disable-next-line react/no-array-index-key
          <TtMenuItem key={idx} value={String(idx)}>
            <LayoutPreview layout={layout} />
          </TtMenuItem>
        ))}
      </TtMenu>
    </TtDropdown>
  )
}

export { NewMix }
